import React from 'react'
import { Card, CardContent } from '@material-ui/core'
import '../App.css'


const Lastpage = ( ) => (
    <div>
        <Card className="Form2-Card">
            <CardContent className="Form2-Card-C" >
                <h1 className="Form2-Heading">Thanks</h1>
            </CardContent>
        </Card>
    </div>
);

export default Lastpage
